
// Libraries
var React = require('react');
var sneakpeek = require('sneakpeek');
var PubSub = require('pubsub-js');

// Components
var SearchInput = require('Search/SearchInput/SearchInput');
var Login = require('../../LoginModule/LoginModule');
var CountrySelector = require('CountrySelect/CountrySelectOverlay');
var Checkbox = require('Checkbox/CheckboxModule');
var AlgoliaSearchModule = require('AlgoliaSearch/AlgoliaSearchModule');

// Styles
require('./MainNavigationMenu.scss');

// Assets
var logoImg = require('images/logo-new.svg');
var closeIcon = require('images/close.svg');

class MainNavigationMenu extends React.Component {
	constructor(props) {
		super(props);

		this.cookieKey = "accessibility-cookie";
		this.cookieValue = true;
		this.state = {
			logonEnabled: false,
			darkness:false
		};

		PubSub.subscribe('DarknessToggled-searchBar', this.toggleDarknessCheckboxState);
	}

	componentDidMount() {
		sneakpeek(this.navMenuHandle);
		const accessibilitycookie = this.getCookie(this.cookieKey);
		const darkness = accessibilitycookie === null ? false : accessibilitycookie === 'true';
		if (darkness === true){
			document.querySelector('body').classList.toggle('Darkness');
		}

		this.setState({
			logonEnabled: window.spurs_login_data.enabled,
			darkness
		});

		if (typeof window === "undefined") return;

		if (window.location.hash) {

			this.navMenuHandle.classList.add('sneakpeek--hidden');

		}

	}

	setCookie = (name, value, days) => {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	getCookie = name => {
		var nameEquals = name + "=";
		var cookies = document.cookie.split(';');

		for(var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i];

			while (cookie.charAt(0) === ' ') {
				cookie = cookie.substring(1, cookie.length)
			};

			if (cookie.indexOf(nameEquals) === 0) {
				return cookie.substring(nameEquals.length, cookie.length)
			};
		}

		return null;
	}

	toggleDarknessCheckboxState = () => {
		this.setState({
			darkness: !this.state.darkness,
		});
	};

	toggleDarkness = () => {
		document.querySelector('body').classList.toggle('Darkness');
		this.setState({
			darkness: !this.state.darkness,
		}, () => {
			this.setCookie(this.cookieKey, this.state.darkness);
		});
	}

	handleDarkness = () => {
		this.toggleDarkness();
		PubSub.publish('DarknessToggled-mainNav', this.state.darkness);
	};

	render() {
		const accessibilityLabel = (this.props.data.accessibilityLink && this.props.data.accessibilityLink.caption && this.props.data.accessibilityLink.url)
			? <a href={this.props.data.accessibilityLink.url} target={this.props.data.accessibilityLink.newWindow ? "_blank" : "_self"} rel={this.props.data.accessibilityLink.newWindow ? "noopener noreferrer" : undefined} >{this.props.data.accessibilityLink.caption}</a>
			: "Accessibility";

		return (
			<div className={"MainNavigationMenu" + (this.props.isMenuOpen ? " is-open" : "")} onKeyDown={this.props.focusHandler}>
				<div className="MainNavigationMenu__container">
					<div className="MainNavigationMenu__handle" onClick={this.props.toggleMenu} ref={(navMenuHandle) => { this.navMenuHandle = navMenuHandle; }}>
						<a href="/" className="MainNavigationMenu__handle__logo"><img src={logoImg} alt="Navigate to home"/></a>
						<button ref={this.props.closeRef} className="MainNavigationMenu__handle__icon js-mainnav-start-tab" onKeyDown={this.props.focusHandler}><img src={closeIcon} alt="Close main navigation"/></button>
					</div>

					<div className="MainNavigationMenu__content">

						<div className="MainNavigationMenu__search">
							<AlgoliaSearchModule mode="header" searchPageUrl={this.props.data.searchPagePath} />
						</div>

						{this.state.logonEnabled &&
								<Login />
						}

						{/* {this.state.loginStatus && this.state.loginStatus.isLoggedIn && this.state.logonEnabled && <Login />} */}

						{(this.props.data.stadiumSiteLink && this.props.data.stadiumSiteLink.url !== '' && this.props.data.stadiumSiteLink.caption) &&
							<p className="MainNavigationMenu__stadium">
								<a href={this.props.data.stadiumSiteLink.url} className="MainNavigationMenu__stadium__link" rel={this.props.data.stadiumSiteLink.newWindow ? "noreferrer noopener" : undefined} target={this.props.data.stadiumSiteLink.newWindow ? "_blank" : "_self"}>
									{this.props.data.stadiumSiteLink.caption}
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
										<path fill="currentColor" d="M42.8 18.1c-5.2.2-10.3.4-15.5.5-.7 0-1.5.1-2.2.1-2.6.1-2.6 4.1 0 4 4.3-.1 8.6-.3 12.9-.4-5.8 5.7-11.6 11.5-17.4 17.3l-2.9 2.9c-1.8 1.8 1 4.7 2.8 2.8l20-20c-.2 3.3-.3 6.7-.5 10 0 .7-.1 1.5-.1 2.2-.1 1.1 1 2 2 2 1.1 0 1.9-.9 2-2 .2-5.1.5-10.2.7-15.3 0-.7.1-1.5.1-2.2.1-1-.9-2-1.9-1.9z"/>
									</svg>
								</a>
							</p>
						}

						<nav className="MainNavigationMenu__links" aria-label="Main">
							<ul className="MainNavigationMenu__links__top">
								{this.props.data.prominentLinks.map((item, index) => {
									return (
										<li className="MainNavigationMenu__item" key={index}>
											<a className={"MainNavigationMenu__links__bold" + (item.mobileOnly ? " mobile-only" : "")} href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} key={index} role="listitem">{ item.caption }</a>
										</li>
									);
								})}
							</ul>
							<ul className="MainNavigationMenu__links__bottom">
								{this.props.data.regularLinks.map((item, index) => {
									return (
										<li className="MainNavigationMenu__item" key={index}>
											<a className="MainNavigationMenu__links__light" href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} key={index} role="listitem">{ item.caption }</a>
										</li>
									);
								})}
							</ul>
						</nav>

						<ul className="MainNavigationMenu__trends">
							<li className="MainNavigationMenu__trends__list__item">
								<a className="MainNavigationMenu__trends__title" role="listitem" tabIndex="0">{this.props.data.latestTrends.title}</a>
							</li>
							{this.props.data.latestTrends.links.map((item, index, array) => {
								return (
									<li className="MainNavigationMenu__trends__list__item" key={index}>
										<a className={"MainNavigationMenu__trends__item" + (index === array.length - 1 ? " js-mainnav-end-tab" : "")} href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} key={index}># <span>{item.caption}</span></a>
									</li>
								);
							})}
						</ul>

						{(this.props.data.accessibilityLink && this.props.data.accessibilityLink.caption && this.props.data.accessibilityLink.url) &&
							<p className="MainNavigationMenu__accessibility"><a href={this.props.data.accessibilityLink.url} target={this.props.data.accessibilityLink.newWindow ? "_blank" : "_self"} className="MainNavigationMenu__content__accessibility-link">{this.props.data.accessibilityLink.caption}</a></p>
						}

						<CountrySelector />

						{this.props.data.subscribeLink ?
							<a href={this.props.data.subscribeLink.url} className="MainNavigationMenu__subscribe" target={this.props.data.subscribeLink.newWindow ? "_blank" : "_self"} rel={this.props.data.subscribeLink.newWindow ? "noreferrer noopener" : undefined}>
								{this.props.data.subscribeLink.caption}
								<svg viewBox="0 0 100.354 100.352" xmlns="http://www.w3.org/2000/svg" className="MainNavigationMenu__subscribe__icon">
									<path fill="currentColor" d="M93.09 76.224c.047-.145.079-.298.079-.459V22.638c0-.162-.032-.316-.08-.462-.007-.02-.011-.04-.019-.06a1.492 1.492 0 0 0-.276-.46c-.008-.009-.009-.02-.017-.029-.005-.005-.011-.007-.016-.012a1.504 1.504 0 0 0-.442-.323c-.013-.006-.023-.014-.036-.02a1.48 1.48 0 0 0-.511-.123c-.018-.001-.035-.005-.053-.005-.017-.001-.032-.005-.049-.005H8.465c-.017 0-.033.004-.05.005l-.048.005a1.497 1.497 0 0 0-.518.125c-.01.004-.018.011-.028.015-.17.081-.321.191-.448.327-.005.005-.011.006-.016.011-.008.008-.009.019-.017.028a1.5 1.5 0 0 0-.277.461c-.008.02-.012.04-.019.061-.048.146-.08.3-.08.462v53.128c0 .164.033.32.082.468l.018.059a1.5 1.5 0 0 0 .28.462c.007.008.009.018.016.026.006.007.014.011.021.018.049.051.103.096.159.14.025.019.047.042.073.06.066.046.137.083.21.117.018.008.034.021.052.028.181.077.38.121.589.121h83.204c.209 0 .408-.043.589-.121.028-.012.054-.03.081-.044.062-.031.124-.063.181-.102.03-.021.057-.048.086-.071.051-.041.101-.082.145-.129l.025-.022c.008-.009.01-.021.018-.03a1.5 1.5 0 0 0 .275-.458c.01-.022.015-.043.022-.065zM9.965 26.04l25.247 23.061L9.965 72.346V26.04zm51.746 21.931c-.104.068-.214.125-.301.221-.033.036-.044.083-.073.121l-11.27 10.294-37.736-34.469h75.472L61.711 47.971zm-24.275 3.161 11.619 10.613a1.496 1.496 0 0 0 2.023 0l11.475-10.481 25.243 23.002H12.309l25.127-23.134zm27.342-1.9L90.169 26.04v46.33L64.778 49.232z"/>
								</svg>
							</a>
						: null}
					</div>
				</div>
			</div>
		)
	}
}

module.exports = MainNavigationMenu;



// WEBPACK FOOTER //
// ./src/components/Navigation/MainNavigation/MainNavigationMenu.js